module.exports = function () {
    return {
        restrict: 'E',
        scope: {},
        transclude: true,
        replace: true,
        require: '^bwsAccordionGroup',
        link(scope, element, attrs, groupCtrl) {
          scope.toggle = function () {
            groupCtrl.toggleAccordion();
          };
          element.click(() => {
            scope.toggle();
            element.find('.btn_icon').toggleClass('open');
          });
        },
        template: require('./accordion-header-template.html')
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/accordion/accordion-header.js
 **/